(function(angular) {
    'use strict';
    angular.module('wtApp.wtDropdown', ['ui.bootstrap.dropdown', 'pascalprecht.translate']);
})(window.angular);
